<template>
  <div class="groups-table-container">
    <div class="table-header">
      <h3>Csoportok listája</h3>
      <p>{{ groups.length }} csoport található</p>
    </div>
    
    <div class="table-wrapper">
      <table class="modern-table">
        <thead>
          <tr>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Fix név
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
                Változtatható név
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                Nap
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12,6 12,12 16,14"/>
                </svg>
                Időpont
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="3,6 5,6 21,6"/>
                  <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"/>
                </svg>
                Műveletek
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(grp, index) in groups" :key="grp.id" class="table-row">
            <td class="fixed-name">
              <div class="cell-content">
                <div class="group-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                <span class="group-name">{{ grp.def_name }}</span>
              </div>
            </td>
            <td class="editable-name">
              <div class="cell-content">
                <span
                  v-if="!grp.isEditing"
                  @dblclick="startEditing(index)"
                  class="editable-text"
                  :title="'Dupla kattintás a szerkesztéshez'"
                >
                  {{ grp.name }}
                </span>
                <div v-else class="edit-input-wrapper">
                  <input
                    type="text"
                    v-model="grp.name"
                    @blur="stopEditing(index)"
                    @keyup.enter="stopEditing(index)"
                    @keyup.escape="cancelEditing(index)"
                    class="edit-input"
                    ref="editInput"
                    :placeholder="'Csoport neve'"
                  />
                  <div class="edit-actions">
                    <button class="edit-btn edit-btn--save" @click="stopEditing(index)" title="Mentés">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20,6 9,17 4,12"/>
                      </svg>
                    </button>
                    <button class="edit-btn edit-btn--cancel" @click="cancelEditing(index)" title="Mégse">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </td>
            <td class="schedule-day">
              <div class="cell-content">
                <span class="day-badge" v-for="(s, i) in scheduleList(grp)" :key="'d' + i">{{ s.day }}</span>
              </div>
            </td>
            <td class="schedule-time">
              <div class="cell-content">
                <span class="time-display" v-for="(s, i) in scheduleList(grp)" :key="'t' + i">{{ s.time }}</span>
              </div>
            </td>
            <td class="actions">
              <div class="cell-content">
                <button class="btn btn-danger btn-sm" @click="delGrp(index)" title="Csoport törlése">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3,6 5,6 21,6"/>
                    <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"/>
                  </svg>
                  Törlés
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div v-if="groups.length === 0" class="empty-state">
      <div class="empty-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      </div>
      <h4>Nincsenek csoportok</h4>
      <p>Még nem hozott létre csoportokat</p>
    </div>
  </div>
</template>



<script>

import axios from 'axios';

export default {
  data(){
    return {
      currentlyEditingIndex: null,
      originalName: '', // Store original name for cancel functionality
    }
  },
  props: {
    groups: {
      type: Array,
      required: true,
    }
  },
  methods: {
    // Normalize a group's schedule (string, single object, or array) into a
    // list of {day, time} slots for rendering.
    scheduleList(grp) {
      try {
        let s = grp.schedule;
        if (typeof s === 'string') s = JSON.parse(s);
        if (!Array.isArray(s)) s = [s];
        return s.filter(x => x && x.day);
      } catch (e) {
        return [];
      }
    },
    startEditing(i) {
      if (this.currentlyEditingIndex !== null) {
        this.stopEditing(this.currentlyEditingIndex);
      }
      this.currentlyEditingIndex = i;
      this.originalName = this.groups[i].name; // Store original name
      this.groups[i].isEditing = true;
      
      // Focus the input after the DOM updates
      this.$nextTick(() => {
        const inputs = this.$refs.editInput;
        if (inputs && inputs[i]) {
          inputs[i].focus();
          inputs[i].select();
        }
      });
    },
    async stopEditing(i) {
      const updatedItem = this.groups[i];
      this.currentlyEditingIndex = null;
      this.groups[i].isEditing = false;

      // Only update if the name actually changed
      if (updatedItem.name !== this.originalName && updatedItem.name.trim() !== '') {
        try {
          const response = await axios.post(this.$BACKEND_HOST + '/api/updategroupname', {
            id: updatedItem.id,
            name: updatedItem.name.trim(),
          });
          console.log('Item updated successfully:', response.data);
          this.$emit('update-items', this.groups);
        } catch (error) {
          console.error('Error updating item:', error);
          // Revert to original name on error
          updatedItem.name = this.originalName;
        }
      } else if (updatedItem.name.trim() === '') {
        // Revert to original name if empty
        updatedItem.name = this.originalName;
      }
      
      this.originalName = '';
    },
    cancelEditing(i) {
      // Revert to original name
      this.groups[i].name = this.originalName;
      this.groups[i].isEditing = false;
      this.currentlyEditingIndex = null;
      this.originalName = '';
    },
    async delGrp(i) {
      if (!confirm('Biztosan törölni szeretné ezt a csoportot?')) {
        return;
      }
      
      const delId = this.groups[i].id;
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/delgroup', {
          id: delId,
          name: "",
        });
        if(response.data["message"] == "done"){
          this.groups.splice(i,1);
          this.$emit('update-items', this.groups);
        }
      } catch (error) {
        console.error('Error deleting group:', error);
        alert('Hiba történt a csoport törlése során.');
      }
    }
  }
};
</script>

<style scoped>
/* Modern Groups Table Container */
.groups-table-container {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  overflow: hidden;
}

/* Table Header */
.table-header {
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.table-header h3 {
  color: var(--color-heading);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
}

.table-header p {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin: 0;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Modern Table */
.modern-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--card-bg);
}

.modern-table thead {
  background: var(--color-background-mute);
}

.modern-table th {
  padding: 1rem 1.5rem;
  text-align: left;
  font-weight: 600;
  color: var(--color-heading);
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.th-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.th-content svg {
  color: var(--primary-blue);
  flex-shrink: 0;
}

/* Table Rows */
.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid var(--color-border);
}

.table-row:hover {
  background: var(--color-background-mute);
}

.table-row:last-child {
  border-bottom: none;
}

.modern-table td {
  padding: 1rem 1.5rem;
  vertical-align: middle;
  border-bottom: 1px solid var(--color-border);
}

.cell-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* Fixed Name Column */
.fixed-name .cell-content {
  gap: 0.75rem;
}

.group-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 8px;
  color: white;
  flex-shrink: 0;
}

.group-name {
  font-weight: 500;
  color: var(--color-text);
}

/* Editable Name Column */
.editable-text {
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  display: inline-block;
  min-width: 120px;
}

.editable-text:hover {
  background: var(--color-background-mute);
  border-color: var(--color-border);
}

.edit-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 200px;
}

.edit-input {
  flex: 1;
  padding: 0.5rem 0.75rem;
  border: 2px solid var(--primary-blue);
  border-radius: 6px;
  background: var(--white);
  color: var(--color-text);
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.edit-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.edit-actions {
  display: flex;
  gap: 0.25rem;
}

.edit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.edit-btn--save {
  background: var(--success);
  color: white;
}

.edit-btn--save:hover {
  background: #059669;
  transform: scale(1.05);
}

.edit-btn--cancel {
  background: var(--error);
  color: white;
}

.edit-btn--cancel:hover {
  background: #dc2626;
  transform: scale(1.05);
}

/* Schedule Day Column */
.day-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: white;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Schedule Time Column */
.time-display {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text);
  background: var(--color-background-mute);
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  border: 1px solid var(--color-border);
}

/* Actions Column */
.actions .cell-content {
  justify-content: flex-end;
}

/* Button styles moved to components.css */

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
}

.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: var(--color-background-mute);
  border-radius: 50%;
  color: var(--color-text-muted);
  margin-bottom: 1.5rem;
  box-shadow: var(--shadow-sm);
}

.empty-state h4 {
  color: var(--color-heading);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.empty-state p {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .table-header {
    padding: 1.25rem 1.5rem;
  }
  
  .table-header h3 {
    font-size: 1.125rem;
  }
  
  .modern-table th,
  .modern-table td {
    padding: 0.75rem 1rem;
  }
  
  .modern-table th {
    font-size: 0.8rem;
  }
  
  .th-content {
    gap: 0.25rem;
  }
  
  .th-content svg {
    width: 14px;
    height: 14px;
  }
  
  .group-icon {
    width: 28px;
    height: 28px;
  }
  
  .edit-input-wrapper {
    min-width: 150px;
  }
  
  .edit-input {
    font-size: 0.8rem;
    padding: 0.375rem 0.5rem;
  }
  
  .edit-btn {
    width: 24px;
    height: 24px;
  }
  
  .day-badge {
    font-size: 0.7rem;
    padding: 0.2rem 0.5rem;
  }
  
  .time-display {
    font-size: 0.8rem;
    padding: 0.2rem 0.5rem;
  }
  
  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
  
  .empty-state {
    padding: 2rem 1.5rem;
  }
  
  .empty-icon {
    width: 64px;
    height: 64px;
  }
  
  .empty-state h4 {
    font-size: 1.125rem;
  }
}

@media (max-width: 480px) {
  .table-header {
    padding: 1rem;
  }
  
  .modern-table th,
  .modern-table td {
    padding: 0.5rem 0.6rem;
  }
  
  .modern-table th {
    font-size: 0.75rem;
    white-space: nowrap;
  }
  
  .th-content span {
    font-size: 0.75rem;
  }
  
  .th-content svg {
    width: 14px;
    height: 14px;
  }
  
  .group-icon {
    width: 24px;
    height: 24px;
  }
  
  .group-name {
    font-size: 0.875rem;
  }
  
  .editable-text {
    min-width: 80px;
    padding: 0.375rem 0.5rem;
    font-size: 0.8rem;
  }
  
  .edit-input-wrapper {
    min-width: 120px;
  }
  
  .edit-input {
    font-size: 0.75rem;
    padding: 0.25rem 0.375rem;
  }
  
  .edit-btn {
    width: 20px;
    height: 20px;
  }
  
  .day-badge {
    font-size: 0.65rem;
    padding: 0.15rem 0.375rem;
  }
  
  .time-display {
    font-size: 0.75rem;
    padding: 0.15rem 0.375rem;
  }
  
  .btn-sm {
    padding: 0.2rem 0.375rem;
    font-size: 0.7rem;
  }
  
  .btn-sm span {
    display: none;
  }
  
  .empty-state {
    padding: 1.5rem 1rem;
  }
  
  .empty-icon {
    width: 56px;
    height: 56px;
  }
  
  .empty-state h4 {
    font-size: 1rem;
  }
  
  .empty-state p {
    font-size: 0.8rem;
  }
}

/* Dark mode adjustments */
@media (prefers-color-scheme: dark) {
  .edit-input {
    background: var(--gray-700);
    color: var(--gray-100);
  }
  
  .time-display {
    background: var(--gray-700);
    color: var(--gray-100);
    border-color: var(--gray-600);
  }
}
</style>